import React, { FunctionComponent } from "react";
import { Claim } from "../../../../types";
import "../DetailView.css";

type ProjectManagerProps = {
  dataSelected: Claim;
};

const ProjectManager: FunctionComponent<ProjectManagerProps> = props => {
  const { dataSelected } = props;

  const getProjectManager = () => {
    if (!dataSelected) {
      return null;
    }

    return (
      <div className="format-section">
        {dataSelected.projectManagerName && (
          <div className="format-fields">
            <div className="label">Name</div>
            <div>
              <div className="value">{dataSelected.projectManagerName}</div>
            </div>
          </div>
        )}
        {dataSelected.projectManagerPhoneNumber && (
          <div className="format-fields">
            <div className="label">Phone</div>
            <div className="value">
              {dataSelected.projectManagerPhoneNumber}
            </div>
          </div>
        )}
        {dataSelected.projectManagerEmail && (
          <div className="format-fields">
            <div className="label">Email</div>
            <div className="value">
              <a href={"mailto:" + dataSelected.projectManagerEmail}>
                {dataSelected.projectManagerEmail}
              </a>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="detail-wrapper">
      <div className="heading">Project Manager</div>
      {getProjectManager()}
    </div>
  );
};

export default ProjectManager;
